import React, { PureComponent, createRef } from "react";

export default class Text extends PureComponent {
  state = {
    fontSize: this.props.widget.data.fontSize || window.innerWidth / 4,
  };

  container = createRef();
  content = createRef();

  componentDidMount = () => {
    this.setBackground();
    this.fitText();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => this.fitText());
    }
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.widget.data !== this.props.widget.data) {
      this.setBackground();
      if (!this.props.widget.data.autoFontSize && this.props.widget.data.fontSize) {
        this.setState({ fontSize: this.props.widget.data.fontSize });
      }
      this.fitText();
    }
  };

  setBackground = () => {
    document.body.style.background = this.props.widget.data.bgColor || "";
  };

  fitText = () => {
    const container = this.container.current;
    const content = this.content.current;
    if (!this.props.widget.data.autoFontSize || !container || !content) return;

    const style = window.getComputedStyle(container);
    const maxWidth =
      container.clientWidth -
      parseFloat(style.paddingLeft) -
      parseFloat(style.paddingRight);
    const maxHeight =
      container.clientHeight -
      parseFloat(style.paddingTop) -
      parseFloat(style.paddingBottom);

    let low = 1;
    let high = Math.max(maxHeight, 1);
    let best = low;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      content.style.fontSize = mid + "px";
      if (content.scrollWidth <= maxWidth && content.scrollHeight <= maxHeight) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    content.style.fontSize = best + "px";
    this.setState({ fontSize: best });
  };

  render() {
    const { widget } = this.props;
    const { fontSize } = this.state;
    const { contentAlign, fontAlign } = widget.data;

    const text = (widget.data.text || "").replace(/\n/g, "<br>");

    return (
      <div
        ref={this.container}
        style={{
          background: widget.data.bgColor,
          color: widget.data.color,
          height: window.innerHeight + "px",
          width: "100%",
          boxSizing: "border-box",
          padding: "10px",
          overflow: "hidden",
          display: "flex",
          alignItems:
            contentAlign === "top"
              ? "flex-start"
              : contentAlign === "bottom"
              ? "flex-end"
              : "center",
          justifyContent:
            fontAlign === "left"
              ? "flex-start"
              : fontAlign === "right"
              ? "flex-end"
              : "center",
        }}
        id="doc"
      >
        <div
          ref={this.content}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
          style={{
            maxWidth: "100%",
            textAlign: fontAlign,
            fontWeight: widget.data.isBold ? "bolder" : "normal",
            fontStyle: widget.data.isItalic ? "italic" : "normal",
            fontFamily: widget.data.fontFamily || "Arial",
            fontSize: fontSize + "px",
            lineHeight: 1,
          }}
        ></div>
      </div>
    );
  }
}
